import { clsx } from 'clsx';
import { TIME_SHEET_STATUS } from '@/models/references/references';

/** Couleur par statut : brouillon gris, en cours de validation orange, validée vert, refusée rouge */
const TONES: Record<string, string> = {
  [TIME_SHEET_STATUS.DRAFT]: 'bg-slate-100 text-slate-700 border-slate-200',
  [TIME_SHEET_STATUS.SUBMITTED]: 'bg-amber-100 text-amber-700 border-amber-200',
  [TIME_SHEET_STATUS.PENDING_MANAGER]: 'bg-amber-100 text-amber-700 border-amber-200',
  [TIME_SHEET_STATUS.PENDING_DIRECTOR]: 'bg-amber-100 text-amber-700 border-amber-200',
  [TIME_SHEET_STATUS.VALIDATED]: 'bg-green-100 text-green-700 border-green-200',
  [TIME_SHEET_STATUS.REJECTED]: 'bg-red-100 text-red-700 border-red-200',
};

/** Statut d'une feuille d'heures, libellé de l'API (« En attente du manager »…) */
export function TimeSheetStatusBadge({ reference, label }: { reference: string; label: string }) {
  return (
    <span
      className={clsx(
        'text-xs font-normal px-2 py-0.5 rounded-full border whitespace-nowrap',
        TONES[reference] ?? TONES.DRAFT,
      )}
      data-testid="timesheet-status"
    >
      {label}
    </span>
  );
}
